import { useState, useEffect } from 'react';
import { Save } from 'lucide-react';
import axios from 'axios';
import '../styles/CreateSession.css';

const CreateSessionModal = ({ onClose }) => {
  const [formData, setFormData] = useState({
    moduleId: '',
    lecturerId: '',
    title: '',
    roomId: '',
    groupCode: '',
    sessionDate: '',
    startTime: '',
    endTime: '',
    description: ''
  });

  const [selects, setSelects] = useState({
    lecturers: [],
    groups: [],
    rooms: [],
    modules: [],
  });

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_URL}/courses/formData`)
      .then(res => setSelects(res.data));
  }, []);

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/courses/createSession`, formData);
      console.log('formData', formData);
      onClose(true); // Pass true to indicate success
    } catch (err) {
      console.error('Błąd podczas tworzenia sesji:', err);
      alert('Nie udało się utworzyć sesji. Sprawdź czy wszystkie wymagane pola są wypełnione.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="modal-title">Utwórz nowe wydarzenie</h3>
        <div className="modal-body">
          <div className="form-group">
            <label>Przedmiot *</label>
            <select
              name="moduleId"
              onChange={handleChange}
              className="form-input"
            >
              <option value="">-- wybierz --</option>
              {selects.modules.map(m => (
                <option key={m.module_id} value={m.module_id}>
                  {m.module_name}
                </option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Tytuł zajęć *</label>
            <input
              name="title"
              type="text"
              onChange={handleChange}
              className="form-input"
              placeholder="np. Wykład wiązania"
            />
          </div>
          <div className="form-group">
              <label>Wykładowca</label>
              <select
                name="lecturerId"
                onChange={handleChange}
                className="form-input"
              >
                <option value="">-- wybierz --</option>
                {selects.lecturers.map(l => (
                  <option key={l.lecturer_id} value={l.lecturer_id}>
                    {l.academic_position} {l.first_name} {l.last_name}
                  </option>
                ))}
              </select>
          </div>
          <div className="form-group">
            <label>Grupa *</label>
            <select
              name="groupCode"
              onChange={handleChange}
              className="form-input"
            >
              <option value="">-- wybierz --</option>
              {selects.groups.map(g => (
                <option key={g.group_code} value={g.group_code}>
                  {g.group_name}
                </option>
              ))}
            </select>
          </div>
            
          <div className="form-grid">
            <div className="form-group">
              <label>Sala</label>
              <select
                name="roomId"
                onChange={handleChange}
                className="form-input"
              >
                <option value="">-- wybierz --</option>
                {selects.rooms.map(r => (
                  <option key={r.id} value={r.id}>
                    {r.name} ({r.location} - {r.comment || 'brak opisu'})
                  </option>
                ))}
              </select>
            </div>
              
            <div className="form-group">
              <label>Data zajęć *</label>
              <input
                name="sessionDate"
                type="date"
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>
              
          <div className="form-grid">
            <div className="form-group">
              <label>Start *</label>
              <input
                name="startTime"
                type="time"
                onChange={handleChange}
                className="form-input"
              />
            </div>
              
            <div className="form-group">
              <label>Koniec *</label>
              <input
                name="endTime"
                type="time"
                onChange={handleChange}
                className="form-input"
              />
            </div>
          </div>
          <div className='form-group'>
              <label>Opis (opcjonalne)</label>
              <textarea
                name='description'
                value={formData.description}
                onChange={handleChange}
                placeholder='np. Link teams ...'
                className='form-input'
              />
          </div>
        </div>
        <div className="modal-actions">
          <button onClick={() => onClose(false)} className="button-secondary">Anuluj</button>
          <button onClick={handleSubmit} className="button-primary">
            <Save size={16} /> Utwórz
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateSessionModal;